import { render, staticRenderFns } from "./ClientVersion.vue?vue&type=template&id=26a92284"
import script from "./ClientVersion.vue?vue&type=script&lang=js"
export * from "./ClientVersion.vue?vue&type=script&lang=js"
import style0 from "./ClientVersion.vue?vue&type=style&index=0&id=26a92284&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports